import { render, staticRenderFns } from "./CommentBox.vue?vue&type=template&id=615da14e&scoped=true&"
import script from "./CommentBox.vue?vue&type=script&lang=ts&"
export * from "./CommentBox.vue?vue&type=script&lang=ts&"
import style0 from "./CommentBox.vue?vue&type=style&index=0&id=615da14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615da14e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
